
































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class RoundButton extends Vue {
  @Prop(String) public tooltip: string | undefined;
  @Prop(String) public icon!: string;
  @Prop(String) public iconSize: string | undefined;
  @Prop({ type: String, default: 'primary' }) public color!: string;
  @Prop({ type: Boolean, default: false }) public disabled!: boolean;
}
